import React from "react";
import { Route, Redirect } from "react-router-dom";
import ForgotPassword from "./components/forgotPassword";
import ConfirmForgotPassword from "./components/confirmForgotPassword";
import CurrentUser from "./components/Users/current-user";
import importExport from "./components/Import-Export";
import SiteMetrics from "./components/Dashboard/Site Metrics";
import AWSMetrics from "./components/Dashboard/AWS";
import importExportPriceData from "./components/Import-Export-Price-Data";
import StudioWrapper from "./components/Shared/StudioWrapper";
import Screensaver from "./components/Screensaver";
import PreciousPricingCalculator from "./components/Precious-Pricing-Calculator";

export default [
  <Route key="forgot-password" exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route
    key="confirm-password"
    exact
    path="/confirm-password"
    component={ConfirmForgotPassword}
    noLayout
  />,
  <Route key="profile" path="/profile" component={CurrentUser} exact />,
  <Route key="bulk-products" path="/bulk-products" component={importExport} exact />,
  <Route
    key="sort-order"
    path="/sort-order"
    exact
    render={() => <Redirect to="/ring-material-sort-order" />}
  />,
  <Route
    key="precious-pricing-calculator"
    path="/precious-pricing-calculator"
    component={PreciousPricingCalculator}
    exact
  />,
  <Route key="screensaver" path="/screensaver" component={Screensaver} exact />,
  <Route
    key="export-product-price"
    path="/export-product-price"
    component={importExportPriceData}
    exact
  />,
  <Route key="dashboard-site" path="/dashboard/site" component={SiteMetrics} exact />,
  <Route
    key="dashboard-application"
    path="/dashboard/application"
    component={AWSMetrics}
    exact
  />,
  <Route
    key="studio-wrapper"
    path={["/signet-studio", "/design-pattern-studio"]} // design-pattern-studio
    component={StudioWrapper}
  />,
];
